
































































import * as Moment from "moment";
import { ElTable } from "element-ui/types/table";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { IDocumentPublished } from "../../../../domain/document";
import { DialogMixin } from "../../../system";

@Component
export default class DocumentPublishedHistoryViewerDialog extends Mixins(DialogMixin) {
  $refs!: {
    table: ElTable,
  };

  data(): any {
    return {
      history: [],
      isLoading: false,
    };
  }
  history: IDocumentPublished[];
  isLoading: boolean;

  get shouldShowPrinterName(): boolean {
    return this.$configuration.behavior.document.list.menu.documentPublishedHistory.shouldShowPrinterName;
  }

  toPublishedDateTimeString(row: IDocumentPublished): string {
    return Moment(row.publishedDateTime).format("YY/MM/DD HH:mm");
  }

  toEditionString(row: IDocumentPublished): string {
    return row.edition + "版";
  }

  toPublishedCopiesString(row: IDocumentPublished): string {
    return row.publishedCopies + "部";
  }

  async getDocumentPublishedHistory(documentId: number): Promise<IDocumentPublished[]> {
    try {
      const repository = DomainRegistry.document.getDocumentRepository();
      return await repository.getDocumentPublishedHistory(documentId);
    } catch (e) {
      this.$error("印刷履歴取得失敗", "印刷履歴の取得に失敗しました。", e);
    }
  }

  async refreshHistory(documentId: number): Promise<void> {
    this.isLoading = true;
    this.history = await this.getDocumentPublishedHistory(documentId);
    this.isLoading = false;
  }

  async show(documentId: number): Promise<void> {
    return this.showModal(async () => {
      await this.refreshHistory(documentId);
      await this.waitHidden(true);
    });
  }

  cancel(): void {
    this.isVisible = false;
  }

  @Watch("history")
  onHistoryUpdated() {
    // element-uiのテーブルにスクロールバーが表示される際、ヘッダがずれる問題に対応するため、dataプロパティ更新時に遅延でdoLayoutを呼び出す
    this.$nextTick(() => this.$doWhenValid(t => t.doLayout(), this.$refs.table));
  }
}
